export default "__VITE_ASSET__Cmy0vPyi__"